import React from 'react';
import { svgSprite, Portal } from '../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import css from './PlugModal.module.scss';
import Plug from '../Plug/Plug';

const PlugModal = ({ closeHandler, data = {}, confirmHandler }) => {
    const { title, text, button, icon } = data;
    const widthDimensions = useWindowDimensions();

    return (
        <Portal
            customClass={widthDimensions < 768 ? 'modalBottom' : 'modal'}
            fullWidth={widthDimensions < 768}
            closeHandler={() => {
                closeHandler(false);
            }}
        >
            <div className={css.plugModal}>
                {widthDimensions < 768 ? (
                    <div
                        onClick={() => {
                            closeHandler(false);
                        }}
                        className={css.plugModalDecor}
                    />
                ) : (
                    <>
                        <div
                            onClick={() => {
                                closeHandler(false);
                            }}
                            className={css.plugModalClose}
                        >
                            <p>
                                {svgSprite('cross', {
                                    className: css.plugModalCloseSvg,
                                    fill: 'var(--greyExtraDarkColor)'
                                })}
                            </p>
                        </div>
                    </>
                )}
                <Plug
                    plugImg={icon}
                    plugTitle={title}
                    plugDescription={text}
                    styles={{
                        btnGroup: {
                            width: '100%'
                        }
                    }}
                    btnGroups={[
                        [
                            {
                                text: button,
                                style: {
                                    width: '100%'
                                },
                                onClick: confirmHandler
                                    ? confirmHandler
                                    : () => {
                                          closeHandler(false);
                                      }
                            }
                        ]
                    ]}
                />
            </div>
        </Portal>
    );
};

export default PlugModal;
